module.exports = __webpack_public_path__ + "media/images/partners/eco-xpress-d5e68a0fbde64c1383b8f5e7aab61e55.png";